export default "__VITE_ASSET__DQpevK0L__"